<template>

  <div class="section d-flex">

    <div class="menu_section hidden-md-and-down"></div>
    <div class="container_section">

      <v-container>

        <h1 class="py-10">{{ $t("Hello") }} {{ user.displayName }}</h1>

        <Reporters />

      </v-container>

    </div>
    
  </div>

</template>

<script>

import { mapGetters } from "vuex";
import Reporters from '@/components/reporters/Reporters' ;

export default {
  name: "Home",

  computed: {

    ...mapGetters({
      user: 'user/current'
    })

  },
  components: {
    Reporters,
  },
  watch: {
    user() {
      
      console.log('LOGHIERO');

      if(this.user.loggedin){
        console.log('Nais hoor LOGGEDIN');
      }else{
        console.log('Nais hoor LOGOUT');
      }

    },
  },
  
  data () {
    return {
      contest: 'loading'
    }
  },
  methods: {

    get_locales(locales){

      return Object.keys(locales) ;

    }

  },
  created() {

    console.log('NODE_ENV');
    // console.log(user);

    // let _this = this ;

    
    // firebase.auth().currentUser.getIdToken(/* forceRefresh */ false).then(function(idToken) {
      
    //   const config = {
    //       headers: { Authorization: "Bearer " + idToken }
    //   };

    //   var api_endpoint = 'https://api.crowdsite.com/v1/projects/57962' ;
    //   // var api_endpoint = 'http://0.0.0.0:8085/v1/projects/55527' ;
      
    //   axios.get( 
    //     api_endpoint,
    //     config
    //   ).then(function(response) {
    //       // console.log(response.data.title)
    //       _this.contest = response.data.title ;
    //   })
    //   .catch(error => {
    //       console.log(error.response)
    //   });

      
    // }).catch(function(error) {
      
    //   console.log(error);

    // });

  }

};
</script>
